/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';
import { useSelect } from '@wordpress/data';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import {
	useBlockProps,
	InspectorControls
} from '@wordpress/block-editor';

import {
	PanelBody,
	PanelRow,
	TextControl
} from '@wordpress/components';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */
export default function Edit({ attributes, setAttributes }) {
	const { menu } = attributes;

	const onMenuChange = (newMenu) => {
		setAttributes({ menu: newMenu });
	};
    const onFbChange = (newFb) => {
		setAttributes({ fbLink: newFb });
	};
    const onIgChange = (newIg) => {
		setAttributes({ igLink: newIg });
	};
    const onLnChange = (newLn) => {
		setAttributes({ lnLink: newLn });
	};

	return (
		<>
			<InspectorControls>
				<PanelBody title={__('Menu Settings', 'main-navigation')}>
					<PanelRow>
						<TextControl
							label={__('Menu Name', 'main-navigation')}
							value={menu}
							onChange={onMenuChange}
						/>
					</PanelRow>
					<PanelRow>
						<TextControl
							label={__('Facebook Link', 'main-navigation')}
							value={attributes.fbLink}
							onChange={onFbChange}
						/>
					</PanelRow>
					<PanelRow>
						<TextControl
							label={__('Instagram Link', 'main-navigation')}
							value={attributes.igLink}
							onChange={onIgChange}
						/>
					</PanelRow>
					<PanelRow>
						<TextControl
							label={__('LinkedIn Link', 'main-navigation')}
							value={attributes.lnLink}
							onChange={onLnChange}
						/>
					</PanelRow>
				</PanelBody>
			</InspectorControls>

			<nav id="top-nav" {...useBlockProps()}>
				EXE Main Navigation

			</nav>
		</>
	);
}

/*
<!--
				{menuItemsData.map((menuItem) => {
					return (
						<div key={menuItem.id} class="menu-block">
							<a href={menuItem.url} class="menu-item">{menuItem.title}</a>
						</div>
					);
				})}
				-->
 */
